import React, { useState } from 'react';
import { Button, Modal, Table } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { MSG_ERROR_SERVER, MSG_LOADING_INFORMATION } from '../../../constants/messages';
import { ICON_CANCEL, ICON_SEARCH } from '../../extras/icons';
import { ErrorMessage, WaitingMessage } from '../../extras/toastMessages';
//Axios
import clienteAxios from '../../../config/axios';
//Función principal
const AudienceActsList = props => {
    //Tomo los props
    const { acts, show, handleClose, audience, setSelectedAct, setSelectedText, setShowPreview} = props;
    //Inicializo el state local
    const [ loading, setLoading ] = useState(false);
    //Manejo la visualización
    const handleView = async act => {
        //Hago la consulta
        try{
            //Cargo la espera
            WaitingMessage(MSG_LOADING_INFORMATION);
            //Hago la consulta
            const response = await clienteAxios.get(`/acta/ver-sae/${act.id}`);
            //Oculto la espera
            Swal.close();
            //Seteo acta
            setSelectedAct(act);
            setSelectedText(response.data);
            //Oculto esta ventana
            // handleClose();
            //Timer
            setTimeout(() => {
                //Muestro ventana
                setShowPreview(true);
            }, 300);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            // onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Listado de Actas <small><strong>Audiencia #{ audience.id }</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <Table responsive hover>
                        <thead className="thead-light">
                            <tr>
                                <th>Descripción</th>
                                <th>Ver</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                acts.map(act => (
                                    <tr key={`aact${act.id}`}>
                                        <td className="align-middle text-center">{ act.type } #{ act.id }</td>
                                        <td className="align-middle text-center">
                                            <Button variant="light" size="sm" onClick={() => handleView(act)}>
                                                <ICON_SEARCH />
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                    <ICON_CANCEL /> Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AudienceActsList;